module.exports = __webpack_public_path__ + "files/de3aca0c467716badc956d6846a093c5.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/animals_nature-2.png
// module id = 509
// module chunks = 76